import { Component } from '@angular/core';
import { Filter } from './MartMax/models/filter.model';
import * as $ from 'jquery';
import { from } from 'rxjs/observable/from';
import { Injector } from '@angular/core';

@Component({
  selector: 'martmax-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() {
  }

  public ngOnInit() {

  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.component.ts